import {
  ArrowRightLeft,
  CalendarDays,
  CircleCheck,
  CircleX,
  Megaphone,
  MessageCircle,
  Trophy,
  UserRoundPlus,
  type LucideIcon,
} from 'lucide-react';
import type { NotificationEventType } from '@/types/notifications';

export type NotificationCatalogEntry = {
  title: string;
  icon: LucideIcon;
  /** Solid chip background (icon is white) */
  chipClassName: string;
};

export const NOTIFICATION_CATALOG: Record<NotificationEventType, NotificationCatalogEntry> = {
  'lead.assigned': {
    title: 'Novo lead atribuído ao usuário',
    icon: UserRoundPlus,
    chipClassName: 'bg-[#2563EB]',
  },
  'lead.campaign_entered': {
    title: 'Novo lead no CRM',
    icon: Megaphone,
    chipClassName: 'bg-[#0EA5E9]',
  },
  'calendar.ai_created': {
    title: 'Novo agendamento feito pela IA',
    icon: CalendarDays,
    chipClassName: 'bg-[#7C3AED]',
  },
  'opportunity.pipeline_changed': {
    title: 'Mudança de pipeline',
    icon: ArrowRightLeft,
    chipClassName: 'bg-[#F97316]',
  },
  'opportunity.won': {
    title: 'Novo lead ganho',
    icon: Trophy,
    chipClassName: 'bg-[#16A34A]',
  },
  'opportunity.lost': {
    title: 'Novo lead perdido',
    icon: CircleX,
    chipClassName: 'bg-[#DC2626]',
  },
  'conversation.opened': {
    title: 'Conversa aberta',
    icon: MessageCircle,
    chipClassName: 'bg-[#1E40AF]',
  },
  'conversation.closed': {
    title: 'Conversa concluída',
    icon: CircleCheck,
    chipClassName: 'bg-[#16A34A]',
  },
  'whatsapp.connected': {
    title: 'WhatsApp conectado',
    icon: MessageCircle,
    chipClassName: 'bg-[#25D366]',
  },
};
